import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const getDeclareAPI = params => common.requestRaw(apiUrl + 'Declare', params, 'get');
export const getDeclareMailAPI = params => common.requestRaw(apiUrl + 'Declare/External', params, 'get');
export const getDeclareExamAPI = params => common.requestRaw(apiUrl + 'Exam', params, 'get');
export const putDeclareAPI = params => common.requestRaw(apiUrl + 'Declare', params, 'put');
export const deleteDeclareAPI = params => common.requestRaw(apiUrl + 'Declare', params, 'delete');

// [대상자 별 신고 상세]
export const getDeclareDetailAPI = params => common.requestRaw(apiUrl + 'Declare/Detail', params, 'get');



// WEBPACK FOOTER //
// ./src/script/libs/declareLib.js